

import { Vue, Component, Prop } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteRepositoryInterface, { Website, WebsiteSearchResponseInterface } from "@/services/Website/interfaces";
import { ServerInterface } from "@/services/Server/Interfaces";

@Component({
  mixins: [Themeable],
  inject: [
    'websiteRepository',
  ],
})
export default class RenameWebsiteDialog extends Vue {
  @Prop() public domain!: string;

  public visible: boolean = true;

  public newDomain: string = '';
  public search: string = '';

  public items: string[] = ['dns', 'email'];

  public selectedItems: string[] = [];

  private websiteRepository!: WebsiteRepositoryInterface;

  private readonly DOMAIN_REGEX = /^(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

  public checkingDomainAvailability: boolean = false;
  public isDomainAvailability: boolean = false;
  public dnsPlanCollapsed = true;

  private availabilityTimeout = undefined;

  public isChecked(item: string): boolean {
    return !this.selectedItems.includes(item);
  }

  public handleCheckboxChange(item: string, target?: boolean): void {

    const index = this.selectedItems.indexOf(item);
    if (index > -1 && (target === undefined || !target)) {
      this.selectedItems.splice(index, 1);
    } else if (index <= -1 && (target === undefined || target)) {
      this.selectedItems.push(item);
    }
  }

  public get domainValid(): boolean {
    const domain = (this.newDomain || '').trim();
    if (!domain) {
      return false;
    }

    return this.DOMAIN_REGEX.test(domain);
  }

  public get searchValid(): boolean {
    const domain = (this.search || '').trim();
    if (!domain) {
      return false;
    }

    return this.DOMAIN_REGEX.test(domain);
  }

  public rename(): void {
    this.$emit('renameDomain', this.newDomain.trim(), this.selectedItems);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  public async searchWebsite(): Promise<void> {
    if (this.search.toLowerCase() === this.newDomain.toLowerCase()) {
      return;
    }

    if (this.availabilityTimeout) clearTimeout(this.availabilityTimeout);

    this.checkingDomainAvailability = true;
    this.search = this.newDomain.trim().toLowerCase();

    let response: WebsiteSearchResponseInterface | undefined;
    try {
      response = await this.websiteRepository.searchWebsites(1, this.search);
    } finally {
      setTimeout(() => {
        if (response) {
          this.isDomainAvailability = response.Websites.filter(x => x.domain.toLowerCase() === this.search).length <= 0;
        }
        this.checkingDomainAvailability = false
      }, 250);
    }
  }
}
